<template>
    <div>
        <div :class="{ 'block-content': !getSubPlans.length }">
            <h3>Create New Commission</h3>
            <label for="name">Subscription Name:</label>
            <select v-model="selectedSubPlan">
                <option v-for="(subPlan, index) in getSubPlans" :key="index" :value="subPlan">{{ subPlan }}</option>
            </select>
            <label for="percent">Commission Percent:</label>
            <input :disabled="!getSubPlans.length" v-model="percent" type="number" step="0.01" required>
            <button @click="createCommission" :disabled="!getSubPlans.length">Create Commission</button>
        </div>
        <p v-if="!getSubPlans.length">All available commission were assigned with percentage</p>
    </div>
</template>


<script>
export default {
    props: {
        subPlans: {
            type: Array
        },
        commissions: {
            type: Array
        },
        role: {
            type: String
        }
    },
    data() {
        return {
            selectedSubPlan: '',
            name: '',
            percent: 0
        }
    },
    methods: {
        createCommission() {
            if (!this.selectedSubPlan || isNaN(this.percent)) {
                alert('Please fill in all fields with valid data.')
                return
            }

            const newCommission = {
                name: this.selectedSubPlan,
                percent: parseFloat(this.percent)
            }

            axios.post(`/admin/set-commission/${this.role}`, newCommission)
                .then(response => {
                    this.$emit('commissionCreated', response.data);
                })
                .catch(error => {
                    console.error('Error creating commission:', error);
                })

            this.selectedSubPlan = ''
            this.percent = 0
        }
    },
    computed: {
        getSubPlans() {
            return this.subPlans.filter(item => !this.commissions.some(stItem => stItem.name === item))
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .block-content {
        opacity: 0.5;
    }
</style>
